// Views
import Index from '../views/Index';
import Login from '../views/Auth/Login';
import Logout from '../views/Auth/Logout';
import ForgotPassword from '../views/Auth/ForgotPassword';
import ResetPassword from '../views/Auth/ResetPassword';
import Establishment from '../views/Establishment';
import Administration from '../views/Administration';
import Roles from '../views/Roles';
import Medias from '../views/Medias';
import Camps from '../views/Products/Camps/Camps';
import CampMarketing from '../views/Products/Camps/CampMarketing';
import CampLogistic from '../views/Products/Camps/CampLogistic';
import CampTranslation from '../views/Products/Camps/CampTranslation';
import CampCreation from '../views/Products/Camps/CampCreation';
import Extras from '../views/Products/Extras/Extras';
import ExtraCreation from '../views/Products/Extras/ExtraCreation';
import ExtraMarketing from '../views/Products/Extras/ExtraMarketing';
import ExtraLogistic from '../views/Products/Extras/ExtraLogistic';
import ExtraTranslation from '../views/Products/Extras/ExtraTranslation';
import Accommodations from '../views/Products/Accommodations/Accommodations';
import AccommodationCreation from '../views/Products/Accommodations/AccommodationCreation';
import AccommodationMarketing from '../views/Products/Accommodations/AccommodationMarketing';
import AccommodationLogistic from '../views/Products/Accommodations/AccommodationLogistic';
import AccommodationTranslation from '../views/Products/Accommodations/AccommodationTranslation';
import Packages from '../views/Package/Packages';
import PackageCreation from '../views/Package/PackageCreation';
import PackageEdition from '../views/Package/PackageEdition';
import CampStocks from '../views/Stocks/CampStocks';
import ExtraStocks from '../views/Stocks/ExtraStocks';
import AccommodationStocks from '../views/Stocks/AccommodationStocks';
import CampYields from '../views/Yields/CampYields';
import ExtraYields from '../views/Yields/ExtraYields';
import AccommodationYields from '../views/Yields/AccommodationYields';
import EstablishmentList from '../views/Establishments/EstablishmentList';
import Seasons from '../components/views/establishment/Seasons/Seasons';

export default [
  {
    path: '/',
    element: <Index />,
  },

  // ---- AUTH
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/logout',
    element: <Logout />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },

  {
    path: '/reset-password',
    element: <ResetPassword />,
  },

  // ---- ADMIN
  {
    path: '/admin',
    element: <Administration />,
  },
  {
    path: '/roles',
    element: <Roles />,
  },
  {
    path: '/establishments',
    element: <EstablishmentList />,
  },
  {
    path: '/establishment',
    element: <Establishment />,
  },

  // ---- MEDIAS
  {
    path: '/medias',
    element: <Medias />,
  },

  // ---- PRODUCTS
  // -- CAMPS
  {
    path: '/products/camps',
    element: <Camps />,
  },
  {
    path: '/products/camps/new',
    element: <CampCreation />,
  },
  {
    path: '/products/camps/marketing',
    element: <CampMarketing />,
  },
  {
    path: '/products/camps/logistic',
    element: <CampLogistic />,
  },
  {
    path: '/products/camps/translate',
    element: <CampTranslation />,
  },
  // -- EXTRAS
  {
    path: '/products/extras',
    element: <Extras />,
  },
  {
    path: '/products/extras/new',
    element: <ExtraCreation />,
  },
  {
    path: '/products/extras/marketing',
    element: <ExtraMarketing />,
  },
  {
    path: '/products/extras/logistic',
    element: <ExtraLogistic />,
  },
  {
    path: '/products/extras/translate',
    element: <ExtraTranslation />,
  },
  // -- ACCOMMODATIONS
  {
    path: '/products/accommodations',
    element: <Accommodations />,
  },
  {
    path: '/products/accommodations/new',
    element: <AccommodationCreation />,
  },
  {
    path: '/products/accommodations/marketing',
    element: <AccommodationMarketing />,
  },
  {
    path: '/products/accommodations/logistic',
    element: <AccommodationLogistic />,
  },
  {
    path: '/products/accommodations/translate',
    element: <AccommodationTranslation />,
  },

  // ---- PACKAGES
  {
    path: '/packages',
    element: <Packages />,
  },
  {
    path: '/packages/edit',
    element: <PackageEdition />,
  },
  {
    path: '/packages/new',
    element: <PackageCreation />,
  },

  // ---- STOCKS
  // -- CAMPS
  {
    path: '/stocks/camps',
    element: <CampStocks />,
  },
  // -- EXTRAS
  {
    path: '/stocks/extras',
    element: <ExtraStocks />,
  },
  // -- ACCOMMODATIONS
  {
    path: '/stocks/accommodations',
    element: <AccommodationStocks />,
  },

  // ---- YIELDS
  // -- CAMPS
  {
    path: '/yields/camps',
    element: <CampYields />,
  },
  // -- EXTRAS
  {
    path: '/yields/extras',
    element: <ExtraYields />,
  },
  // -- ACCOMMODATIONS
  {
    path: '/yields/accommodations',
    element: <AccommodationYields />,
  },

  // ---- SEASONS
  {
    path: '/seasons',
    element: <Seasons />,
  },
];
